<template>
  <div class="container-fluid text-left">
    <div class="card nw-card">
      <div class="card-header nw-card-header">
        <div class="row">
          <div class="col-xs-12 col-sm-6 text-xs-center text-sm-left"><h4>Sleep Sessions - {{ nc.ctx.patientName }}</h4></div>
          <div class="col-xs-12 col-sm-6 text-xs-center text-sm-right"><h4>{{ patientOid }}</h4></div>
        </div>
      </div>
      <div class="card-body">
        <div class="row mt-2 text-center">
          <div class="col-4 border-right">
            <button class="btn nw-btn-outline-info-sm" @click="moveDate(-30)">-30 Days</button>
            <button class="btn nw-btn-outline-info-sm ml-2" @click="moveDate(0)">Today</button>
            <button class="btn nw-btn-outline-info-sm ml-2" @click="moveDate(30)">+30 Days</button>
          </div>
          <div class="col-4 border-right">
            <button class="btn" :class="numDays==30 ? ' nw-btn-info-sm'  :'nw-btn-outline-info-sm'" @click="setNumDays(30)">30 Days</button>
            <button class="btn ml-2" :class="numDays==60 ? ' nw-btn-info-sm'  :'nw-btn-outline-info-sm'" @click="setNumDays(60)">60 Days</button>
            <button class="btn ml-2" :class="numDays==90 ? ' nw-btn-info-sm'  :'nw-btn-outline-info-sm'" @click="setNumDays(90)">90 Days</button>
          </div>
          <div class="col-4">
            <a class="btn nw-btn-outline-info-sm" title="Download PDF" target="_blank" :href="pdfURL"><i class="fa fa-file-pdf-o"></i></a>
            <a class="btn nw-btn-outline-info-sm ml-2" title="Download Summary CSV" target="_blank" :href="csvURL"><i class="fa fa-file-excel-o"></i></a>
            <a class="btn nw-btn-outline-info-sm ml-2" title="Download Stats CSV" target="_blank" :href="statsURL"><i class="fa fa-file-excel-o"></i></a>
          </div>
        </div>
        <div class="row border-top mt-1">
          <div class="col-3 text-right">First Session Date:</div>
          <div class="col-3 font-weight-bold">{{ startDate.toLocaleDateString() }}</div>
          <div class="col-3 text-right">Min # Interventions:</div>
          <div class="col-3 font-weight-bold">{{ summ.minInt}}</div>
        </div>
        <div class="row mt-1">
          <div class="col-3 text-right">Last Session Date:</div>
          <div class="col-3 font-weight-bold">{{ endDate.toLocaleDateString() }}</div>
          <div class="col-3 text-right">Max # Interventions:</div>
          <div class="col-3 font-weight-bold">{{ summ.maxInt}}</div>
        </div>
        <div class="row mt-1">
          <div class="col-3 text-right">Utilization:</div>
          <div class="col-3 font-weight-bold">{{ summ.utilization.toFixed(2)}}%</div>
          <div class="col-3 text-right">Avg # Interventions:</div>
          <div class="col-3 font-weight-bold">{{ summ.avgInt}}</div>
        </div>
        <table class="table table-striped table-sm nw-barchart">

          <tbody>
            <tr class="text-center">
              <td class="border-left" width="10%"></td>
              <td :colspan="maxSegments/2" class="border-left">PM</td>
              <td :colspan="maxSegments/2" class="border-left border-right">AM</td>
              <td colspan="3 text-center" width="15%">Measures</td>
            </tr>
            <tr class="border-bottom">
              <td>Date</td>
              <td :colspan="maxSegments/8">12</td>
              <td :colspan="maxSegments/8">3</td>
              <td :colspan="maxSegments/8">6</td>
              <td :colspan="maxSegments/8">9</td>
              <td :colspan="maxSegments/8">12</td>
              <td :colspan="maxSegments/8">3</td>
              <td :colspan="maxSegments/8">6</td>
              <td :colspan="maxSegments/8">9</td>
              <td class="border-left text-center">Dur</td>
              <td class="border-left text-center">Int</td>
              <td class="border-left text-center">Thr</td>
            </tr>
            <tr class="border-bottom" v-for="item in summ.days">
              <td class="border-right">{{ item.day }}</td>
              <td  v-for="hour in item.hour.slice(0,maxSegments/2)" :class="barClass(hour)" @click="select(hour)"></td>
              <td class="border-left" :class="barClass(item.hour[11])" @click="select(item.hour[maxSegments/2])"></td>
              <td v-for="hour in item.hour.slice(maxSegments/2 + 1, maxSegments)" :class="barClass(hour)" @click="select(hour)"></td>
              <td class="text-center border-left">{{ item.nodata == true ? '' : item.duration.toFixed(1)}}</td>
              <td class="text-center border-left">{{ item.nodata == true ? '---' : item.interventions}}</td>
              <td class="text-center border-left">{{ item.nodata == true ? '' : item.threshold}}</td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import NetClient from '@/util/netclient.js'

export default {
  data () {
    return {
      maxSegments: 24,
      nc: NetClient,
      numDays: 30,
      endDate: new Date(), 
      startDate: this.calculateStartDate(new Date(), 30),
      patientOid: '',
      summ: {
    		patientName: "Name",
    		patientID: "777777.888",
    		patientEmail: "",
    		patientPhone: "",
	  		maxInt: 0,
    		minInt: 1000,
    		avgInt: 0,
    		utilization: 0,
		    days: []
      }
    }
  },
  computed: {
      csvURL : function() {
        var url = process.env.VUE_APP_HOST_NAME + 'rest/report?repID=ssexcel&uid=' + NetClient.ctx.uid + '&token=' + NetClient.ctx.token
        url += '&endDate=' + this.endDate.toLocaleDateString() + '&numDays=' + this.numDays

        return url
      },
      statsURL : function() {
        var url = process.env.VUE_APP_HOST_NAME + 'rest/report?repID=statsexcel&uid=' + NetClient.ctx.uid + '&token=' + NetClient.ctx.token
        url += '&endDate=' + this.endDate.toLocaleDateString() + '&numDays=' + this.numDays

        return url
      },
      pdfURL : function() {
        var url = process.env.VUE_APP_HOST_NAME + 'rest/report?repID=sspdf&uid=' + NetClient.ctx.uid + '&token=' + NetClient.ctx.token
        url += '&endDate=' + this.endDate.toISOString() + '&numDays=' + this.numDays

        return url
      }
  },
  mounted () {
    this.refreshSummary()
    this.loadPatient()
  },
  methods : {
    loadPatient () {
      const fullHash = location.hash;
      const hashContent = fullHash.startsWith('#') ? fullHash.substring(1) : fullHash;
      const queryStringIndex = hashContent.indexOf('?');
      let queryString = '';
      if (queryStringIndex !== -1) {
        queryString = hashContent.substring(queryStringIndex + 1); // e.g., "country=de&city=berlin"
      }

      NetClient.doRequest('rest/patient', { action: 'patient'}).then(msg => {
        if(typeof msg.data != 'undefined') this.patientOid = msg.data.oid
      })
    },
    select (oid) {
      if(isNaN(oid)) return
      NetClient.sessionID = oid
      this.$router.push({name: 'SessionDetail'})
    },
    barClass (_segment)
    {
       var o = _segment.oid
       var num = _segment.numInterventions
      if (!isNaN(_segment) && _segment > 0) return 'bg-primary'
      else if(_segment == 0) return ''
     },
    setStartDate () {
      this.startDate.setTime(this.calculateStartDate(this.endDate, this.numDays))
    },
    moveDate(_days) {
      if(_days == 0) this.endDate = new Date()
      else this.endDate = new Date(this.endDate.getTime() + (_days * 86400000))
      this.setStartDate()
      this.refreshSummary()
    },
    refreshSummary () {
      NetClient.doRequest('rest/patient', { action: 'getSleepSessionSummary', endDate: this.endDate.toISOString(), numDays: this.numDays}).then(msg => {
        if(typeof msg.data != 'undefined') this.summ = msg.data
        this.updateMetadata(msg.data)
      })
    },
    updateMetadata (data) {
        const parent = this.$route.matched[this.$route.matched.length - 2]
        var meta = parent["meta"]
        if (typeof data != 'object' || typeof meta != 'object') {
          console.log("Summary -- cannot update " + meta + " with " + data)
        }
        meta["maxAccelerometer"] = data.maxAccelerometer
        meta["maxDurationSeconds"] = data.maxDurationSeconds
        meta["maxGyroscope"] = data.maxGyroscope
        meta["maxHeartrate"] = data.maxHeartrate
        meta["maxStress"] = data.maxStress
        meta["minAccelerometer"] = data.minAccelerometer
        meta["minGyroscope"] = data.minGyroscope
        meta["minHeartrate"] = data.minHeartrate
        meta["minStress"] = data.minStress
      
        // console.log("Summary -- Updating meta data at " + parent.path + ":\n")
        // console.log(parent["meta"])
    },
    setNumDays (_days) {
      this.numDays = _days
      this.setStartDate()
      this.refreshSummary()
    },
    calculateStartDate(_endDate, _days) {
      var _start = new Date(_endDate);
      _start.setDate(_start.getDate() - _days);
      _start.setHours(0);
      _start.setMinutes(0);
      _start.setSeconds(0);
      _start.setMilliseconds(0);
      return _start;
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
